/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Alert from 'components/Alert';
import PageLoader from 'components/PageLoader';
import './TeamPage.scss';
import { Button } from 'antd';

function TeamPage() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const permissions = useSelector((state) => state.user.planPermissions);

  const getRedirectUrl = async () => {
    try {
      setLoading(true);
      window.location.href = process.env.REACT_APP_TEAMBUZZ_BASE_URL;
    } catch (error) {
      setLoading(false);
      Alert('something went wrong', 'Please contact support team for this', 'error');
    }
  };

  useEffect(() => {
    if (permissions?.can_view_teams) {
      getRedirectUrl();
    }
  }, []);

  const getRedirectIndexPage = () => {
    if (!loading) {
      navigate('/');
    }
  };

  return (
    <div className="team-page">
      {loading ? (
        <PageLoader />
      ) : (
        <div className="team-page-error">
          <Button size="large" onClick={getRedirectIndexPage}>
            Go to Dashboard
          </Button>
        </div>
      )}
    </div>
  );
}

export default TeamPage;
